import { Branding, DisabledPrompt, Link, useModel, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { MainContentSection } from 'components/shared/containers/MainContentContainer';
import ControlView from 'components/shared/views/BaseRowView/components/ControlView';
import UIRadio from 'components/ui/UIRadio';
import React, { useState } from 'react';
import { Card, Util } from "model";
import "./styles.css";

/**
 * @function AlertsView
 * @param {DECIMAL} transactionAmount - This is the transaction amount for the spend limits.
 * @param {DECIMAL} monthlyAmount - This is the monthly amount for the spend limits.
 * @return {React.Component}
 * @exported true
 * @description The main component for AlertsView
 * @example
 * <AlertsView transactionAmount="100.87" monthlyAmount="6.40" />
 */
export default function AlertsView(props) {
  const transactionAmount = props.transactionAmount ?? "100.00";
  const monthlyAmount = props.monthlyAmount ?? "1,500.00";
  const model = useModel();
  const cardID = useParams().cardID ?? Util.getDefaultCardID(model);
  const navigate = useRoute();
  
  const card = Card.initByID(cardID);
  const isCredit = card.type.toLowerCase() === "credit";

  const [showAlert, setShowAlert] = useState(true);
  const [ radio, setRadio ] = useState("Alert for selected transactions");
  
  const myRegionAlertsRoute = evt => navigate(`/home/locationalerts/${cardID}`);
  const merchantTypesAlertsRoute = evt => navigate(`/home/merchantalerts/${cardID}`);
  const transactionTypesAlertsRoute = evt => navigate(`/home/transactionalerts/${cardID}`);
  const spendLimitsAlertsRoute = evt => navigate(`/home/spendalerts/${cardID}`);
  const enableAdditionalAlerts = evt => navigate(`/home/enableadditionalalerts/${ cardID }`);

  const onChange = (value, label) => {
    setShowAlert(label !== "No transaction alerts");
    setRadio(label);
  };

  return (
    <div className="alerts-view">
      <MainContentSection text="Transaction Alerts">
        <UIRadio label="Alert for all transactions" name="transaction-alert" dataPoint="Transaction_All_Card_Radio" onChange={ onChange } value={ radio === "Alert for all transactions" } />
        <UIRadio label="No transaction alerts" name="transaction-alert" dataPoint="Transaction_Alert_Radio" onChange={onChange} value={ radio === "No transaction alerts" } />
        <UIRadio label="Alert for selected transactions" name="transaction-alert" dataPoint="Transaction_Selected_Card_Radio" onChange={onChange} value={ radio === "Alert for selected transactions" }/>



       {showAlert &&
        <>
          <ControlView leftIcon="MapLocationIcon" controlText="Locations" controlSubText={
              <>
                My Regions
                <Branding id="Alerts_Locations_International_chw23" value="true">, International</Branding>
              </>
            }  dataPoint="Transaction_Alert_My_Region" onClick={ myRegionAlertsRoute } />
          <ControlView leftIcon="ShopIcon" controlText="Merchant Types" controlSubText="Department Store, Entertainment, Gas Station, Grocery, Hous..." dataPoint="Transaction_Alert_Department" onClick={ merchantTypesAlertsRoute } />
          <ControlView leftIcon="TagIcon" controlText="Transaction Types" controlSubText="In-Store, Online / eCommerce, Recurring / Autopay, ATM, Other" dataPoint="Transaction_Alert_ATM" onClick={ transactionTypesAlertsRoute } />

          <Branding id="monthly_spendlimit_chw23" value="true">
            <ControlView leftIcon="MeterLimitsIcon" controlText="Spend Limits" controlSubText={"Transaction: $"+transactionAmount+", Monthly: $"+monthlyAmount} dataPoint="Transaction_Alert_Spend_Limit" onClick={ spendLimitsAlertsRoute } />
          </Branding>

          <Branding id="monthly_spendlimit_chw23" value="false">
            <ControlView leftIcon="MeterLimitsIcon" controlText="Spend Limits" controlSubText={`Transaction: $${ transactionAmount }`} dataPoint="Transaction_Alert_Spend_Limit" onClick={ spendLimitsAlertsRoute } />
          </Branding>
        </>}
      </MainContentSection>

      {
        isCredit &&
        <Branding id="additional_alerts_chw23" value="true">
          <MainContentSection text="Additional Alerts">
            <ControlView leftIcon="AlertIcon" controlText="Enable Additional Alerts" controlSubText="Click to set up" onClick={ enableAdditionalAlerts } />
          </MainContentSection>
        </Branding>
      }

      <DisabledPrompt><Link className="tell-me-more">Tell me more</Link></DisabledPrompt>
    </div>
  )
}
